"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Node_1 = require("./Node");
const simplification_1 = require("./transformations/simplification");
var CommandName;
(function (CommandName) {
    CommandName["Transform"] = "transform";
    CommandName["Transformations"] = "transformations";
    CommandName["Evaluate"] = "evaluate";
    CommandName["Rules"] = "rules";
    CommandName["Help"] = "help";
    CommandName["Tree"] = "tree";
})(CommandName = exports.CommandName || (exports.CommandName = {}));
var ExecuteError;
(function (ExecuteError) {
    ExecuteError["UndefinedTransformation"] = "No transformation has been set";
    ExecuteError["MissingParameters"] = "Missing required parameters";
    ExecuteError["InvalidTransformation"] = "Transformation does not exist";
    ExecuteError["UndefinedExpression"] = "No expression has been set";
    ExecuteError["CommandNotFound"] = "Command not found";
})(ExecuteError = exports.ExecuteError || (exports.ExecuteError = {}));
exports.commandRegistry = immutable_1.Map([
    [
        CommandName.Transform,
        {
            executeConstructor: (_) => (namespace) => {
                const { expression, transformations } = namespace;
                if (expression === undefined) {
                    return {
                        namespace: namespace,
                        stdOut: ExecuteError.UndefinedExpression,
                    };
                }
                const setSimplification = transformations.get(simplification_1.default.name, simplification_1.default);
                const transformed = expression.transform(setSimplification, transformations);
                return {
                    namespace: Object.assign({}, namespace, { expression: transformed }),
                    stdOut: transformed.toString(),
                };
            },
            description: 'Transform current expression using the active transformation',
        },
    ],
    [
        CommandName.Evaluate,
        {
            executeConstructor: (_) => (namespace) => {
                if (namespace.expression === undefined) {
                    return {
                        namespace: namespace,
                        stdOut: ExecuteError.UndefinedExpression,
                    };
                }
                const evaluated = namespace.expression.evaluate();
                return {
                    namespace: Object.assign({}, namespace, { expression: evaluated }),
                    stdOut: evaluated.toString(),
                };
            },
            description: 'Evaluate current expression',
        },
    ],
    [
        CommandName.Rules,
        {
            executeConstructor: (command) => (namespace) => {
                const parameter = command.parameters.first();
                if (parameter === undefined) {
                    return {
                        namespace: namespace,
                        stdOut: ExecuteError.MissingParameters,
                    };
                }
                const { transformations } = namespace;
                const transformation = transformations.get(parameter);
                if (transformation === undefined) {
                    return {
                        namespace: namespace,
                        stdOut: ExecuteError.UndefinedTransformation,
                    };
                }
                return {
                    namespace: namespace,
                    stdOut: transformation.toString(),
                };
            },
            description: 'List rules of given transformation - Requires transformation name as a string parameter',
        },
    ],
    [
        CommandName.Help,
        {
            executeConstructor: (_) => (namespace) => {
                return {
                    namespace: namespace,
                    stdOut: immutable_1.List(['--- algebrain version 0.0.5 ---', 'Commands:'])
                        .concat(exports.commandRegistry
                        .entrySeq()
                        .map(([name, spec]) => `- ${name}: ${spec.description}`))
                        .join('\n'),
                };
            },
            description: 'Print this message',
        },
    ],
    [
        CommandName.Tree,
        {
            executeConstructor: (_) => (namespace) => {
                if (!(namespace.expression instanceof Node_1.default)) {
                    return {
                        namespace: namespace,
                        stdOut: ExecuteError.UndefinedExpression,
                    };
                }
                return {
                    namespace: namespace,
                    stdOut: namespace.expression.treeify('', '\xa0'),
                };
            },
            description: 'Tree representation of expression',
        },
    ],
    [
        CommandName.Transformations,
        {
            executeConstructor: (_) => (namespace) => {
                return {
                    namespace: namespace,
                    stdOut: `[ ${namespace.transformations.keySeq().join(', ')} ]`,
                };
            },
            description: 'List all defined transformations',
        },
    ],
]);
const commandNotFound = {
    executeConstructor: (command) => (namespace) => {
        return {
            namespace: namespace,
            stdOut: ExecuteError.CommandNotFound,
        };
    },
    description: 'Placeholder command',
};
class Command {
    constructor(name, parameters = immutable_1.List(), registry = exports.commandRegistry) {
        this.name = name;
        this.parameters = parameters;
        this.execute = registry.get(this.name, commandNotFound).executeConstructor(this);
    }
    toString() {
        return this.parameters.isEmpty()
            ? this.name
            : `${this.name}: ${this.parameters.join(', ')}`;
    }
    equals(other) {
        return (other !== undefined &&
            this.constructor === other.constructor &&
            this.name === other.name &&
            this.parameters === other.parameters);
    }
}
exports.default = Command;
//# sourceMappingURL=Command.js.map